export function mergedAccumulatedLevels(levelContentData) {
  const merged = [];

  const sortedData = levelContentData
    .filter((item) => item.level !== 9999)
    .sort((a, b) => a.level - b.level);

  for (let i = 0; i < sortedData.length; i++) {
    const currentLevel = sortedData[i];
    const allSubjectsMap = new Map();

    for (let j = 0; j <= i; j++) {
      const level = sortedData[j];

      const rootTitle = `${level.title}`;

      // Flatten grouped videos/docs into plain arrays
      const flatVideos = (level.videos || []).flatMap(v => v.list || []);
      const flatDocs = (level.docs || []).flatMap(d => d.list || []);
      const flatUtils = Array.isArray(level.utils) ? level.utils : [];

      const fallbackSubject = {
        title: rootTitle,
        videos: flatVideos,
        docs: flatDocs,
        utils: flatUtils
      };

      const subjects = Array.isArray(level.subjects) ? [...level.subjects] : [];

      if (flatVideos.length || flatDocs.length || flatUtils.length) {
        subjects.push(fallbackSubject);
      }

      subjects.forEach((subject) => {
        const cleanTitle = subject.title?.trim() || "Untitled";
        const uniqueKey = `${cleanTitle}__LEVEL__${level.level}`;

        // Merge logic
        if (!allSubjectsMap.has(uniqueKey)) {
          allSubjectsMap.set(uniqueKey, {
            title: cleanTitle,
            videos: Array.isArray(subject.videos) ? subject.videos : [],
            docs: Array.isArray(subject.docs) ? subject.docs : [],
            utils: Array.isArray(subject.utils) ? subject.utils : []
          });
        } else {
          const existing = allSubjectsMap.get(uniqueKey);
          allSubjectsMap.set(uniqueKey, {
            title: cleanTitle,
            videos: Array.from(new Set([...existing.videos, ...(subject.videos || [])])),
            docs: Array.from(new Set([...existing.docs, ...(subject.docs || [])])),
            utils: Array.from(new Set([...existing.utils, ...(subject.utils || [])]))
          });
        }
      });
    }

    merged.push({
      level: currentLevel.level,
      title: currentLevel.title,
      subjects: Array.from(allSubjectsMap.values())
    });
  }

  return merged;
}
